import { ReminderSelectorComponent } from './reminder-selector.component';

export default angular
  .module('sfMobile.components.reminder-selector', [])
  .component('sfReminderSelector', ReminderSelectorComponent).name;
